import { userConstants } from "../constants";

import { IAuthenticationState } from "../contracts/IAuthenticationState";
import { UserInfo } from "../contracts/UserInfo";

import { ILocalizedError } from "src/i18n/error-localization";

const userKey: string = "user";

const serializedUser = localStorage.getItem(userKey);
const user: UserInfo = serializedUser ? JSON.parse(serializedUser) : {};
const initialState: IAuthenticationState = user.token
  ? { isLoggedIn: true, error: null, accessToken: null, userName: user.username }
  : { isLoggedIn: false, error: null, accessToken: null, userName: '' };

export const authenticationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return handleRequestCompleted(action.payload);

    case userConstants.LOGIN_TOKEN_RECEIVED:
      persistUser(action.payload);
      break;

    case userConstants.LOGIN_SUCCESS:
      return handleRequestCompleted(action.payload);

    case userConstants.LOGIN_FAILURE:
      return handleRequestFailed(action.payload);

    case userConstants.LOGOUT:
      return handleLogoutCompleted();
  }

  return state;
};

const handleRequestCompleted = (payload: UserInfo = new UserInfo("", null)): IAuthenticationState => {
  return { isLoggedIn: !!payload.token, error: null, accessToken: payload.token, userName: payload.username };
};

const handleLogoutCompleted = (): IAuthenticationState => {
  return { isLoggedIn: false, error: null, accessToken: null, userName: null };
};

const handleRequestFailed = (error: ILocalizedError): IAuthenticationState => {
  return { isLoggedIn: false, error, accessToken: null, userName: null };
};

export function persistUser(userInfo: UserInfo) {
  const userInfoStr = JSON.stringify(userInfo);
  localStorage.setItem(userKey, userInfoStr);
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.reducer.ts